import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import copy from 'copy-to-clipboard';
import { Popover, Tooltip } from '@getro/rombo';
import { trackEvent } from 'helpers/analytics';
import { getNotSharingClipboardText } from '../helpers/clipboardMessages';
import { CopyLink } from '../helpers/copyLink';

const Content = styled.div`
  min-width: 280px;
  max-width: 320px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.main};
`;

const ContactsSharedPopover = ({ memberFirstName, networkSlug, trigger }) => {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(null);
  const nameForCopy = memberFirstName || 'them';
  const clipboardText = getNotSharingClipboardText({ firstName: nameForCopy, networkSlug });

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const handleCopy = useCallback(() => {
    copy(clipboardText);
    trackEvent('team_members:copy_not_sharing_message');
    setCopied(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setCopied(false), 2000);
  }, [clipboardText]);

  const renderCopyLink = () => {
    if (copied) {
      return <Tooltip content="Copied!" isOpen delayHide={1000} trigger={<CopyLink>Copy message</CopyLink>} />;
    }
    return <CopyLink onClick={handleCopy}>Copy message</CopyLink>;
  };

  return (
    <Popover
      interactive
      position="bottom-start"
      trigger={trigger}
      content={
        <Content>
          This team member is not sharing their synced contacts. Ask them to enable sharing from their Personal
          integrations screen: {renderCopyLink()}
        </Content>
      }
    />
  );
};

ContactsSharedPopover.propTypes = {
  memberFirstName: PropTypes.string.isRequired,
  networkSlug: PropTypes.string.isRequired,
  trigger: PropTypes.node.isRequired,
};

export default ContactsSharedPopover;
